<div class="flex justify-end gap-[12px] text-[14px] py-[30px] leading-[17px] items-center">
	<div class="font-medium text-white">
		Already have an account?
	</div>
	<button nz-button nzType="default" (click)="goToLogin()" [style.border-radius]="'8px'" class="h-[46px] w-[97px] secondary">
		Login
	</button>
</div>